import { IQuickSortState } from "../../IQuickSortState";
import { IQuickSortContext } from '../../IQuickSortContext';
import { QuickSortStep } from '../../enums/QuickSortStep';
import { assertIsDefined } from "../../../tsutils/assertIsDefined";
import { QuickSortLeftRecursionCallState } from "./QuickSortLeftRecursionCallState";

export class QuickSortAssignPartitionIndexState implements IQuickSortState {

  ThisQuickSortStep = QuickSortStep.QuickSortAssignPartitionIndex;
  
  Description = "Assign partition index after return from partition";

  private _savedState : { 
    PoppedPartitionIndex: number,
    SavedPartitionIndex: number | undefined
  } | undefined;

  private _context : IQuickSortContext | undefined;
  
  SetContext(context: IQuickSortContext): void {
    this._context = context;
  } 
  
  Do(): void {
    assertIsDefined(this._context);
    assertIsDefined(this._context.AlgoStack);    

    let poppedPartitionIndex : number = this._context.AlgoStack.pop() as number;
    let savedPartitionIndex : number | undefined = this._context.PartitionIndex;

    if (this._savedState === undefined) {
      this._savedState = {
        PoppedPartitionIndex: poppedPartitionIndex,
        SavedPartitionIndex: savedPartitionIndex
      }
    }
    else {
      this._savedState.PoppedPartitionIndex = poppedPartitionIndex;
      this._savedState.SavedPartitionIndex = savedPartitionIndex;
    }

    this._context.PartitionIndex = poppedPartitionIndex;
    this._context.SortedIndices?.push(poppedPartitionIndex);
  }

  Undo(): void {
    assertIsDefined(this._context);
    assertIsDefined(this._context.AlgoStack);
    assertIsDefined(this._savedState);
    assertIsDefined(this._context.SortedIndices);

    let thePoppedPI : number = this._savedState.PoppedPartitionIndex;

    this._context.AlgoStack.push(this._savedState.PoppedPartitionIndex);
    this._context.PartitionIndex = this._savedState.SavedPartitionIndex;

    let foundIndex = this._context.SortedIndices.indexOf(thePoppedPI);
    if (foundIndex >= 0) {
      let left = this._context.SortedIndices.slice(0, foundIndex);
      let right = this._context.SortedIndices.slice(foundIndex + 1);
      this._context.SortedIndices = [...left, ...right];
    }
  }

  Exit(): void {
    assertIsDefined(this._context);

    this._context.TransitionTo(new QuickSortLeftRecursionCallState());
  }
}
